import { CommonError } from '../../types';
import {
    FETCH_ORDER_HISTORY_FAILURE,
    FETCH_ORDER_HISTORY_REQUEST,
    FETCH_ORDER_HISTORY_SUCCESS,
    FETCH_ORDER_MATCH_HISTORY_FAILURE,
    FETCH_ORDER_MATCH_HISTORY_REQUEST,
    FETCH_ORDER_MATCH_HISTORY_SUCCESS,
} from './constants';
import { OrderHistoryData, OrderMatchHistoryData } from './types';

export interface FetchOrderHistoryRequestAction {
    type: typeof FETCH_ORDER_HISTORY_REQUEST;
}

export interface FetchOrderHistorySuccessAction {
    type: typeof FETCH_ORDER_HISTORY_SUCCESS;
    payload: OrderHistoryData[];
}

export interface FetchOrderHistoryFailureAction {
    type: typeof FETCH_ORDER_HISTORY_FAILURE;
    payload: CommonError;
}

export interface FetchOrderMatchHistoryRequestAction {
    type: typeof FETCH_ORDER_MATCH_HISTORY_REQUEST;
}

export interface FetchOrderMatchHistorySuccessAction {
    type: typeof FETCH_ORDER_MATCH_HISTORY_SUCCESS;
    payload: OrderMatchHistoryData[];
}

export interface FetchOrderMatchHistoryFailureAction {
    type: typeof FETCH_ORDER_MATCH_HISTORY_FAILURE;
    payload: CommonError;
}

export type OrderHistoryActions =
    | FetchOrderHistoryRequestAction
    | FetchOrderHistorySuccessAction
    | FetchOrderHistoryFailureAction
    | FetchOrderMatchHistoryRequestAction
    | FetchOrderMatchHistorySuccessAction
    | FetchOrderMatchHistoryFailureAction;

export const fetchOrderHistoryRequest = (): FetchOrderHistoryRequestAction => ({
    type: FETCH_ORDER_HISTORY_REQUEST,
});

export const fetchOrderHistorySuccess = (orderHistoryDatas: OrderHistoryData[]): FetchOrderHistorySuccessAction => ({
    type: FETCH_ORDER_HISTORY_SUCCESS,
    payload: orderHistoryDatas,
});

export const fetchOrderHistoryFailure = (error: CommonError): FetchOrderHistoryFailureAction => ({
    type: FETCH_ORDER_HISTORY_FAILURE,
    payload: error,
});

export const fetchOrderMatchHistoryRequest = (): FetchOrderMatchHistoryRequestAction => ({
    type: FETCH_ORDER_MATCH_HISTORY_REQUEST,
});

export const fetchOrderMatchHistorySuccess = (
    orderMatchHistoryDatas: OrderMatchHistoryData[],
): FetchOrderMatchHistorySuccessAction => ({
    type: FETCH_ORDER_MATCH_HISTORY_SUCCESS,
    payload: orderMatchHistoryDatas,
});

export const fetchOrderMatchHistoryFailure = (error: CommonError): FetchOrderMatchHistoryFailureAction => ({
    type: FETCH_ORDER_MATCH_HISTORY_FAILURE,
    payload: error,
});
